<mat-card [appearance]="'outlined'"
  class="notice-board__card">

  <div class="notice-board__header">
    <h3>ADR Updates & News</h3>
  </div>

  @if (noticeBoardContent) {
    <div
      class="notice-board__content"
      [innerHTML]="noticeBoardContent | safeHtml">
    </div>
  }

  @if (noticeBoardFooter) {
    <div
      class="notice-board__footer"
      [innerHTML]="noticeBoardFooter | safeHtml">
    </div>
  }

  @if (noticeBoardSecondFooter) {
    <div
      class="notice-board__footer"
      [innerHTML]="noticeBoardSecondFooter | safeHtml">
    </div>
  }
</mat-card>
